export const removeTodasMascaras = stringValue => {
  if (!stringValue) return stringValue;

  let novoValor = stringValue.toString();
  novoValor = novoValor?.replace('-', '');
  novoValor = novoValor?.replace('.', '');
  novoValor = novoValor?.replace('(', '');
  novoValor = novoValor?.replace(')', '');
  novoValor = novoValor?.replace('/', '');
  novoValor = novoValor?.replace(',', '');
  novoValor = novoValor?.replace('R$', '');
  const item = novoValor
    .split('')
    .find(e => e === '-' || e === '.' || e === '(' || e === ')' || e === '/' || e === ',');
  if (item) return removeTodasMascaras(novoValor);
  return novoValor;
};

export const removeEspacos = valor => {
  if (valor) {
    let novoValor = valor.toString();
    novoValor = novoValor?.replace(' ', '');
    const item = novoValor.split('').find(e => e === ' ');
    if (item) return removeEspacos(novoValor);
    return novoValor;
  }
  return valor;
};

export const encodingUrl = valor => {
  if (!valor) return valor;
  const listaEncoding = ['/', '+', '!', '#', '$', '&', '(', ')', '*', ',', ':', '@'];
  let novoValor = valor.toString();
  novoValor = novoValor?.replace('/', '%2F');
  novoValor = novoValor?.replace('+', '%2B');
  novoValor = novoValor?.replace('!', '%21');
  novoValor = novoValor?.replace('#', '%23');
  novoValor = novoValor?.replace('$', '%24');
  novoValor = novoValor?.replace('&', '%26');
  novoValor = novoValor?.replace('(', '%28');
  novoValor = novoValor?.replace(')', '%29');
  novoValor = novoValor?.replace('*', '%2A');
  novoValor = novoValor?.replace(',', '%2C');
  novoValor = novoValor?.replace(':', '%3A');
  novoValor = novoValor?.replace('@', '%40');
  const findSimbolo = novoValor.split('').find(x => listaEncoding.includes(x));
  if (findSimbolo) return encodingUrl(novoValor);
  return novoValor;
};

export const widthLabel = (label, tamanhoMaximo = 50) => {
  if (label?.toString()?.length > tamanhoMaximo) {
    return `${label?.toString()?.substring(0, tamanhoMaximo)} ...`;
  }
  return label;
};

export const removeTagsHtmlDeTexto = (text = '') => {
  const htmlTagRegex = /<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g;
  var textNew = text.replace(/&nbsp;/g, '');
  return textNew.replace(htmlTagRegex, ' ');
};
